module.exports = __webpack_public_path__ + "img/home.6992328d.svg";